import slugify from 'slugify';

export const slugifyHeading = (heading: string): string => {
	return slugify(heading, {lower: true});
};

// Helper function to check if an object has an _id property
export function hasId(obj: unknown): obj is {_id: string} {
	return (
		typeof obj === 'object' && // Ensure it's an object
		obj !== null && // Ensure it's not null
		'_id' in obj && // Check if _id exists
		typeof (obj as {_id: string})._id === 'string' // Ensure _id is a string
	);
}
